package com.jingfangpai.acupoint.model

import com.jingfangpai.common.orm.mapping.Acupoint
import kotlinx.serialization.Serializable

@Serializable
class AcupointDetail: Acupoint() {
    var meridianOthers: List<Acupoint> = listOf()
}
